import PropTypes from "prop-types";
import { ContainerViewStake } from "../../../components/Container";
import { WithdrawFormContainer } from "../styles";
import { FormButton2, FormButtonCancel3 } from "./styles";
import { SuccessGradient } from "../../../components/Icons/SuccessGradient";
import {
  capitalizeText,
  dateFormatNumber,
  formatNumber,
} from "../../../utils/helper";

export const StakeSuccessScreen = ({
  T,
  formValues,
  selectedDuration,
  rewardAmountDisplay,
  votingPowerDisplay,
  energyEarnAmountDisplay,
  startDate,
  endDate,
  onBackHome,
  onCreateAnother,
}) => {
  return (
    <ContainerViewStake>
      <WithdrawFormContainer>
        <div className="flex flex-col gap-[30px] lg:gap-[50px]">
          <div className="text-[20px] lg:text-[32px] leading-[36px] text-center text-[#000000] font-semibold">
            {T("Stake request confirmed")}
          </div>
          <div className="flex justify-center items-center">
            <SuccessGradient className={"w-[52px] lg:w-[80px]"} />
          </div>
          <div className="px-4 lg:px-32">
            <div className="grid grid-cols-[210px_1fr] md:grid-cols-[250px_1fr] gap-y-2.5">
              <div className="text-base text-black capitalize">
                {T("Stake Amount")}
              </div>
              <div className="text-base">{formValues.amount} SGT</div>

              <div className="text-base text-black capitalize">
                {T("Duration")}
              </div>
              <div className="text-base">
                <span>
                  {formatNumber(selectedDuration.duration, 2)}&nbsp;
                  <span className="capitalize">
                    {capitalizeText(T(selectedDuration.durationUnit))}
                  </span>
                </span>
              </div>

              <div className="text-base text-black capitalize">
                {T("Interest rate")}
              </div>
              <div className="text-base">
                {formatNumber(selectedDuration.interestRate, 2)}%
              </div>

              <div className="text-base text-black capitalize">
                {T("Interest Amount")}
              </div>
              <div className="text-base text-aia-red">
                {rewardAmountDisplay}
              </div>

              <div className="text-base text-black capitalize">
                {T("Voting Power")}
              </div>
              <div className="text-base">{votingPowerDisplay}</div>

              <div className="text-base text-black capitalize">
                {T("Est. Monthly Energy Earn")}
              </div>
              <div className="text-base">{energyEarnAmountDisplay}</div>

              <div className="text-base text-black capitalize">
                {T("Start date")}
              </div>
              <div className="text-base">
                {dateFormatNumber(startDate, "YYYY/MM/DD")}
              </div>

              <div className="text-base text-black capitalize">
                {T("End date")}
              </div>
              <div className="text-base">
                {dateFormatNumber(endDate, "YYYY/MM/DD")}
              </div>
            </div>
          </div>
          <div className="text-center font-medium lg:px-20">
            {T(
              "Your stake request has been confirmed. Please check your mailbox for stake result!"
            )}
          </div>

          <div
            className="flex flex-col-reverse lg:flex-row justify-center 
                lg:flex-nowrap flex-wrap items-center gap-2 lg:px-20"
          >
            <FormButtonCancel3
              onClick={onBackHome}
              className="!w-full lg:!w-auto"
            >
              <span>{T("Back to Home")}</span>
            </FormButtonCancel3>
            <FormButton2
              className={"lg:ml-3 ml-0 w-full lg:!w-auto"}
              onClick={onCreateAnother}
            >
              {T("Create another stake")}
            </FormButton2>
          </div>
        </div>
      </WithdrawFormContainer>
    </ContainerViewStake>
  );
};

StakeSuccessScreen.propTypes = {
  T: PropTypes.func.isRequired,
  formValues: PropTypes.shape({
    amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }).isRequired,
  selectedDuration: PropTypes.shape({
    duration: PropTypes.number,
    durationUnit: PropTypes.string,
    interestRate: PropTypes.number,
  }).isRequired,
  rewardAmountDisplay: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  votingPowerDisplay: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  energyEarnAmountDisplay: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  startDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)])
    .isRequired,
  endDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)])
    .isRequired,
  onBackHome: PropTypes.func.isRequired,
  onCreateAnother: PropTypes.func.isRequired,
};

